var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunicative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572.86195,
    height: 457.17618999999996,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_3",
    fill: "#ffb6b6",
    points: "458.34288 450.53314 449.083 450.53222 444.67803 414.81515 458.34477 414.81609 458.34288 450.53314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#2f2e41",
    d: "m426.6174,450.32307l0,0c-0.2883,0.48556 -0.44045,2.05281 -0.44045,2.61751l0,0c0,1.73573 1.40709,3.14282 3.14281,3.14282l28.67676,0c1.18412,0 2.14404,-0.95992 2.14404,-2.14404l0,-1.19391s1.41863,-3.58829 -1.50208,-8.01107c0,0 -3.63002,3.46312 -9.05418,-1.96104l-1.59954,-2.89766l-11.57846,8.46786l-6.41777,0.78996c-1.40405,0.17283 -2.64891,-0.02683 -3.37114,1.18957l0.00001,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_6",
    fill: "#ffb6b6",
    points: "416.24202 450.53314 406.98214 450.53222 402.57717 414.81515 416.2439 414.81609 416.24202 450.53314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#2f2e41",
    d: "m384.51654,450.32307l0,0c-0.2883,0.48556 -0.44045,2.05281 -0.44045,2.61751l0,0c0,1.73573 1.40709,3.14282 3.14281,3.14282l28.67676,0c1.18412,0 2.14404,-0.95992 2.14404,-2.14404l0,-1.19391s1.41863,-3.58829 -1.50208,-8.01107c0,0 -3.63002,3.46312 -9.05418,-1.96104l-1.59954,-2.89766l-11.57846,8.46786l-6.41777,0.78996c-1.40405,0.17283 -2.64891,-0.02683 -3.37114,1.18957l0.00001,0z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_8",
    fill: "#2f2e41",
    points: "473.20269 227.54286 408.76259 229.26126 402.19342 244.72688 394.15617 345.25343 401.02978 433.75117 421.09585 433.75117 421.09585 350.22598 436.25703 298.85656 442.27144 431.17356 462.98699 433.75117 471.48429 342.67583 479.2171 255.8965 473.20269 227.54286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#6c63ff",
    d: "m450.30869,112.40988l-22.33923,0.8592l-2.5776,10.31042s-27.49444,7.73281 -25.77604,18.04323s10.31042,55.84808 10.31042,55.84808c0,0 -9.45121,29.21284 -3.43681,32.64965s67.99191,0 67.99191,0c0,0 5.0402,-12.88802 2.46259,-14.60642s7.73281,-84.20173 6.01441,-85.92013c-1.7184,-1.7184 -30.07205,-10.31042 -30.07205,-10.31042l-2.5776,-6.87361z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_11",
    fill: "#ffb6b6",
    points: "494.12796 198.33001 495.84636 210.35883 476.94393 253.3189 467.49272 248.16369 477.80314 207.78123 479.52154 192.3156 494.12796 198.33001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#6c63ff",
    d: "m476.08473,130.45311s9.45121,-4.29601 16.32482,11.16962c6.87361,15.46562 5.15521,48.97447 5.15521,48.97447c0,0 2.5776,2.5776 0.8592,4.29601s-4.98409,-2.3251 -1.7184,3.13913c1.7184,2.87528 6.87361,2.01608 1.7184,2.87528c-5.15521,0.8592 -3.34862,-1.54204 -1.7184,1.7184c0.8592,1.7184 4.29601,1.7184 0.8592,2.5776c-3.43681,0.8592 -20.72964,-0.61572 -20.72964,-0.61572c0,0 -5.9056,-2.82109 -2.4688,-4.53949s5.15521,-2.05667 3.43681,-2.74674c-1.7184,-0.69007 -6.01441,-0.69007 -3.43681,-3.26767s4.29601,-2.5776 2.5776,-2.5776s-3.65226,-4.1404 -3.65226,-4.1404l2.79305,-56.86289l0.00002,0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-71.527 75.5127 621.398)",
    id: "svg_13",
    fill: "#ffb6b6",
    ry: 7.10333,
    rx: 11.96351,
    cy: 879.67543,
    cx: 544.64265
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_15",
    fill: "#ffb6b6",
    points: "374.43616 194.26023 367.60122 204.30657 324.68807 223.31528 321.17769 213.13791 356.00517 190.24479 367.69532 179.97451 374.43616 194.26023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#6c63ff",
    d: "m406.83722,131.94648s9.87838,3.19353 4.53717,19.2529c-5.34121,16.05937 -29.18847,39.66243 -29.18847,39.66243c0,0 0.16795,3.64141 -2.25965,3.75338s-2.11632,-5.07626 -3.38486,1.16179c-0.66751,3.28247 3.72077,6.12103 -0.66751,3.28247c-4.38828,-2.83856 -1.43543,-3.39569 -2.42761,0.11197c-0.52292,1.8487 2.01665,4.16434 -1.10183,2.48359c-3.11849,-1.68074 -14.90301,-14.42211 -14.90301,-14.42211c0,0 -2.46308,-6.06366 1.23432,-5.01781s5.1951,1.95371 4.39026,0.28598c-0.80484,-1.66773 -3.97931,-4.56228 -0.3379,-4.73024s4.9112,0.98986 3.64141,-0.16795s0.09092,-5.52029 0.09092,-5.52029l40.37675,-40.13611l0.00001,0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-29.1678 -68.0411 181.915)",
    id: "svg_17",
    fill: "#ffb6b6",
    ry: 7.10333,
    rx: 11.96351,
    cy: 403.62939,
    cx: 247.53172
  })), /*#__PURE__*/React.createElement("circle", {
    id: "svg_18",
    fill: "#ffb6b6",
    r: 20.63413,
    cy: 87.57593,
    cx: 440.11331
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#2f2e41",
    d: "m423.63148,70.97927c1.04992,-2.9778 3.96271,-4.78437 7.11945,-4.714c0.13388,0.00295 0.26748,0.00171 0.39989,-0.00373c1.58974,-0.065 3.11562,-0.60797 4.67447,-0.92651c2.90524,-0.59372 5.96856,-0.39494 8.77271,0.5692c0.87162,0.29971 1.74432,0.67658 2.66603,0.67668c0.9217,0.00013 1.92568,-0.50528 2.15048,-1.39911c0.05336,0.80926 0.10658,1.61847 0.1598,2.42768c0.29999,-0.65496 0.59985,-1.30997 0.89985,-1.96496l0.60065,2.61205l1.9244,-2.18301c-0.17209,0.9622 0.38888,1.93197 1.1484,2.54714c0.75951,0.61521 1.6976,0.9555 2.59684,1.33877c3.88098,1.65429 7.52502,4.5832 8.64327,8.65119c0.70654,2.57013 0.33698,5.29783 -0.03742,7.93684c-0.33088,2.33301 -0.69072,4.74665 -1.95886,6.73262c-0.81292,1.27312 -1.98466,2.34439 -2.47962,3.77157c-0.46135,1.33024 -0.28659,2.85326 -0.94303,4.09893c-0.65921,1.25118 -2.0201,1.95907 -3.352,2.43444c-1.3318,0.47556 -2.74766,0.81184 -3.89466,1.63915c-1.14688,0.82743 -2.47808,3.21079 -4.97705,3.08253l-0.80654,-1.51525c-0.82972,-0.67602 2.24083,-0.14007 2.27287,-1.20982c0.03204,-1.06974 -3.69454,-1.73065 -3.16642,-2.66151c0.80997,-1.42739 1.9058,-2.66969 2.81853,-4.0338c1.06741,-1.59528 1.90683,-3.45921 1.53852,-5.40628c-0.14324,-0.75741 -0.49772,-1.47288 -1.03774,-2.02306c-1.55655,-1.58609 -3.29215,-0.88894 -4.97886,-0.66206c-1.16254,0.15652 -2.55103,-0.02417 -3.15474,-1.03003c-0.70614,-1.17679 0.08093,-2.67382 -0.01535,-4.04283c-0.10204,-1.45063 -1.20104,-2.64013 -2.39705,-3.46715c-1.19617,-0.827 -2.55427,-1.42953 -3.63026,-2.40767c-1.07596,-0.97821 -0.90578,-0.47086 -0.43668,-1.8473c-8,6 -6.81789,-4.35984 -12.18885,-3.06488c0.25599,-1.34312 0.61438,-2.66645 1.06899,-3.95584l-0.00002,0.00001z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#e6e6e6",
    d: "m514.99847,439.92346c2.10236,1.09814 4.20631,2.58417 5.79951,5.21429c0.30011,0.49542 0.56771,1.03503 0.81826,1.59436c-0.70653,-5.02893 -2.11607,-9.76099 -4.14754,-13.70258c-0.74926,-1.45374 0.50981,-3.58472 1.26403,-2.12134l0,0.00006c3.22047,1.67316 4.57731,5.58527 5.0952,10.2171c0.64016,-1.65887 1.42743,-3.15601 2.34555,-4.40161c0.37507,-0.50885 0.89736,-0.61536 1.26403,0c0.31361,0.52631 0.37732,1.60938 0,2.12134c1.38531,7.27887 -2.19124,9.53369 -3.42624,13.1579c-0.02757,0.80359 -0.05724,1.59705 -0.08474,2.37177c-0.02724,0.76843 -0.31892,1.2262 -0.65842,1.38257c-0.16446,0.42822 -0.46119,0.72369 -0.76334,0.72369c-0.5064,0 -0.86674,-0.68787 -0.89379,-1.5c-0.09929,-2.97925 -0.40435,-8.15302 -2.17331,-7.87848c-3.76807,0.58478 -3.94239,-2.4632 -4.91441,-4.28619c-0.76465,-1.43408 -0.62761,-3.46887 0.47523,-2.89288l-0.00002,0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#3f3d56",
    d: "m217.91365,457.17619l-176.42479,0c-21.51191,0 -39.01333,-17.50142 -39.01333,-39.01374l0,-379.14912c-0.00001,-21.51191 17.50141,-39.01333 39.01333,-39.01333l176.42479,0c21.51151,0 39.01293,17.50142 39.01293,39.01333l0,379.14912c0,21.51232 -17.50142,39.01374 -39.01293,39.01374z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#3f3d56",
    d: "m256.92674,139.4635c-0.91025,0 -1.65045,0.74021 -1.65045,1.65045l0,52.81453c0,0.91025 0.74021,1.65045 1.65045,1.65045s1.65045,-0.74021 1.65045,-1.65045l0,-52.81453c0,-0.91025 -0.74021,-1.65045 -1.65045,-1.65045z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "#fff",
    d: "m253.21342,39.01362l0,379.14232c0,18.7244 -14.57349,34.04062 -33.00082,35.22894l-0.00826,0c-0.27234,0.01652 -0.54463,0.03304 -0.82523,0.0413c-0.48691,0.02473 -0.97376,0.03299 -1.46888,0.03299c0,0 -1.81551,-0.13206 -5.13294,-0.37962c-3.35042,-0.24756 -8.22749,-0.61892 -14.30946,-1.10578c-1.82372,-0.14032 -3.74651,-0.29712 -5.77659,-0.46213c-4.04358,-0.33011 -8.48331,-0.69321 -13.24488,-1.10583c-1.89801,-0.1568 -3.86206,-0.33006 -5.86735,-0.50338c-10.24931,-0.883 -21.72824,-1.91453 -33.83431,-3.08634c-2.04655,-0.18984 -4.10961,-0.38788 -6.1892,-0.59419c-0.54463,-0.05777 -1.09757,-0.10728 -1.65045,-0.16506c-8.63189,-0.84996 -125.71564,-23.47767 -125.71564,-27.90092l0,-379.1423c-0.00001,-19.50007 15.80311,-35.30319 35.30322,-35.30319l21.07628,0c3.36694,0 6.07366,2.62422 6.36252,5.9829c0.02473,0.22283 0.04951,0.4456 0.09076,0.66843c0.61066,3.3752 3.70526,5.72708 7.13818,5.72708l107.08205,0c3.43292,0 6.52752,-2.35188 7.13818,-5.72708c0.04125,-0.22283 0.06603,-0.4456 0.09081,-0.66843c0.28881,-3.35868 2.99553,-5.9829 6.36247,-5.9829l21.07633,0c19.50007,0 35.30319,15.80312 35.30319,35.30319l0.00002,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "#3f3d56",
    d: "m1.65045,99.8526c-0.91025,0 -1.65045,0.74021 -1.65045,1.65045l0,13.20363c0,0.91025 0.74021,1.65045 1.65045,1.65045s1.65045,-0.74021 1.65045,-1.65045l0,-13.20363c0,-0.91025 -0.74021,-1.65045 -1.65045,-1.65045z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    fill: "#3f3d56",
    d: "m1.65045,139.4635c-0.91025,0 -1.65045,0.74021 -1.65045,1.65045l0,25.58204c0,0.91025 0.74021,1.65045 1.65045,1.65045s1.65045,-0.74021 1.65045,-1.65045l0,-25.58204c0,-0.91025 -0.74021,-1.65045 -1.65045,-1.65045z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    fill: "#3f3d56",
    d: "m1.65045,175.77349c-0.91025,0 -1.65045,0.74021 -1.65045,1.65045l0,25.58204c0,0.91025 0.74021,1.65045 1.65045,1.65045s1.65045,-0.74021 1.65045,-1.65045l0,-25.58204c0,-0.91025 -0.74021,-1.65045 -1.65045,-1.65045z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_30",
    fill: "#e6e6e6",
    ry: 0.31021,
    rx: 0.31021,
    height: 4.12614,
    width: 32.18385,
    y: 9.49024,
    x: 30.12079
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_31",
    fill: "#e6e6e6",
    r: 3.30091,
    cy: 10.31547,
    cx: 202.04914
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_32",
    fill: "#e6e6e6",
    r: 3.30091,
    cy: 10.31547,
    cx: 211.12664
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_33",
    fill: "#e6e6e6",
    r: 3.30091,
    cy: 10.31547,
    cx: 220.20414
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_35"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_36",
    fill: "#ffb6b6",
    points: "244.28861 435.57554 251.90548 433.65739 246.70386 398.49123 235.46309 401.32116 244.28861 435.57554"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_37",
    fill: "#2f2e41",
    d: "m274.62571,444.16981l0,0c0.35421,1.27839 -0.26586,2.56609 -1.38496,2.87616l-15.0206,4.16181s-3.12444,-5.53222 -9.85963,-6.41948l1.93885,8.61412l-7.7486,2.14693l-2.84759,-13.9259s-4.09855,-6.73692 -0.82928,-11.66695c3.26927,-4.93003 -0.07329,-3.4437 -0.07329,-3.4437l-0.65007,-8.92729l12.09049,-1.86735l3.76486,13.25337l9.33382,11.60445l9.4753,1.80784c0.84333,0.1609 1.55491,0.86277 1.81071,1.78599l-0.00001,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_38"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_39",
    fill: "#ffb6b6",
    points: "171.33683 429.46477 178.68032 432.25213 194.54555 400.44003 183.70872 396.32584 171.33683 429.46477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_40",
    fill: "#2f2e41",
    d: "m191.29211,453.87764l0,0c-0.44136,1.25098 -1.68691,1.95188 -2.78201,1.56551l-14.69852,-5.18583s0.60494,-6.32469 -4.40968,-10.90765l-3.34126,8.17302l-7.58244,-2.67518l5.63677,-13.04861s0.49583,-7.87009 5.99859,-10.04103s1.91119,-2.86562 1.91119,-2.86562l4.57726,-7.69206l10.98254,5.38987l-4.49968,13.02224l1.01048,14.85808l6.73441,6.90632c0.59938,0.61468 0.78107,1.59752 0.46233,2.50093l0.00002,0.00001z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_41",
    fill: "#2f2e41",
    d: "m203.22069,114.95674l-38.97219,0c0.05714,-1.82865 -0.33332,-3.6573 -1.13336,-5.2954c-0.01907,1.81912 -0.42859,3.63823 -1.18097,5.2954l-1.77145,0c-2.70484,0 -4.90488,-2.2001 -4.90488,-4.90488l0,-25.32428c0,-12.40027 9.74303,-22.6195 22.12423,-23.20998c0.37145,-0.01907 0.73337,-0.0286 1.10482,-0.0286c10.08588,0 19.09561,6.54298 22.16231,16.23835c4.50489,-2.07617 7.20014,9.72408 8.99066,28.46736c1.36198,4.34288 -1.8762,8.76203 -6.41917,8.76203z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_42",
    fill: "#ffb6b6",
    d: "m279.69664,259.74189c1.93187,4.58009 1.13522,9.28954 -1.77938,10.51892c-2.9146,1.22937 -6.84341,-1.4869 -8.77528,-6.06698c-0.84565,-2.00486 -1.16836,-4.03448 -1.01959,-5.78618l-7.94241,-19.50982l9.23481,-3.53218l6.8495,19.60776c1.35836,1.11599 2.5867,2.76362 3.43235,4.76848z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_43",
    fill: "#6c63ff",
    d: "m194.30624,106.38514l-18.6283,3.89679l2.8572,8.5716l-5.7144,65.55811l9.524,21.11028l58.0964,-4.762l-14.286,-28.572s5.7144,-23.81 -1.9048,-28.572s-20.0004,-28.572 -20.0004,-28.572l-9.9437,-8.65879l0,0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_44",
    fill: "#2f2e41",
    d: "m176.94156,114.07278l-16.50202,6.68555l5.7144,83.8112l-12.3812,72.3824l40.0008,6.6668s-4.762,-160.00319 -7.6192,-162.86039s-9.21278,-6.68555 -9.21278,-6.68555l0,-0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_45",
    fill: "#2f2e41",
    d: "m209.26217,124.52826s10.73783,-6.79387 16.53919,-1.76361c5.80136,5.03026 50.46697,126.62671 50.46697,126.62671l-12.0476,5.23469l-27.62934,-57.93132l-27.32923,-72.16647l0.00001,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_46",
    fill: "#2f2e41",
    d: "m240.02208,329.40065l10.89546,83.74446l-15.2384,0.9524s-7.92397,-21.61943 -16.96224,-47.0866c-1.92387,-5.40015 -3.89534,-10.97167 -5.84775,-16.55283c-2.1143,-6.05713 -4.21912,-12.1145 -6.21914,-17.96213c-4.94296,-14.41947 -9.27637,-27.54356 -11.75264,-36.11516c-0.42859,-1.50463 -0.80952,-2.86662 -1.12382,-4.06665c-6.6668,-25.60052 -10.4764,-92.50661 -10.4764,-92.50661l55.2392,-4.762l0.59048,0.73337l11.79072,14.7336l-0.55241,3.11437l-14.68599,82.37306l4.34294,33.40073l-0.00001,-0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_47",
    fill: "#2f2e41",
    d: "m235.67914,295.99992l4.34294,33.40073l-19.53373,34.39103l-1.77145,3.21923l-26.89577,48.87711l-13.28599,-7.53352s17.28608,-39.72456 28.11487,-75.85856c1.20003,-3.97167 2.31432,-7.90497 3.31433,-11.73363c2.94294,-11.20977 -1.8762,-31.6673 0.00953,-37.30555c6.37156,-19.02893 27.13387,-57.09633 36.77215,-74.34428l3.61911,4.51437l-14.68599,82.37306l0,0.00001z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_48",
    fill: "#2f2e41",
    points: "204.00847 114.31951 223.29794 121.71073 273.77514 269.33272 243.29834 274.09472 229.01234 188.37873 204.00847 114.31951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_49",
    fill: "#ffb6b6",
    d: "m155.78097,273.66572c-0.49097,4.94654 -3.44075,8.70319 -6.58855,8.39076s-5.30156,-4.57564 -4.81059,-9.52218c0.21491,-2.16527 0.90105,-4.10246 1.86862,-5.57025l2.34334,-20.93379l9.80025,1.30888l-3.35025,20.4977c0.66016,1.62935 0.95211,3.66362 0.73719,5.82889l-0.00001,-0.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_50",
    fill: "#2f2e41",
    d: "m167.10634,120.75833s-12.3812,-2.8572 -16.1908,3.8096c-3.8096,6.6668 -5.7144,136.19319 -5.7144,136.19319l13.10112,0.9524l6.89928,-63.8108l1.9048,-77.1444l0,0.00001z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_51",
    fill: "#ffb6b6",
    r: 19.79792,
    cy: 84.27746,
    cx: 182.90744
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_52",
    fill: "#2f2e41",
    d: "m207.76031,82.57514s-9.64447,-2.8572 -15.41886,0c-8.02465,3.97064 -28.51201,0 -28.51201,0l0,-8.94985c0,-5.22486 3.89061,-9.63207 9.07512,-10.28014l14.78452,-1.84806c11.60512,-1.45064 21.85556,7.59826 21.85556,19.2937l0,0.00002c0,0.98546 -0.79887,1.78433 -1.78433,1.78433z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_53",
    fill: "#2f2e41",
    d: "m186.68704,114.95674l-22.43854,0c0.05714,-1.82865 -0.33332,-3.6573 -1.13336,-5.2954c-0.01907,1.81912 -0.42859,3.63823 -1.18097,5.2954l-0.96193,0l0,-40.0008l17.1432,0l8.5716,40.0008z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicative);
export default __webpack_public_path__ + "static/media/communicative.c9eb38051346102ad70fb09535193a85.svg";
export { ForwardRef as ReactComponent };